import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../../../../models/User';

declare var jQuery;

@Component({
  selector: 'app-ctv-app-mfa',
  templateUrl: './ctv-app-mfa.html'
})
export class CtvAppMfaComponent implements OnInit {
  @Input() data;
  isFreemium: boolean;

  constructor(private _user: User) {}

  ngOnInit() {
    setTimeout(fn => {
      jQuery('[enTooltip]').tooltip({ animation: false });
    }, 100);
    this.isFreemium = this._user.isFreemium();
  }
}
